"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var defaultProps = function defaultProps(WrappedComponent) {
  return /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    var _theme$components;
    var theme = (0, _reactJss.useTheme)();
    if (!theme) {
      throw new Error("You must use <ThemeProvider>, if you want to use the icf-react-components library!\n" + "See more at https://icfreactcomponents.integ.icfsys.com/?path=/docs/intro-get-started--docs#get-started");
    }
    var customProps = theme === null || theme === void 0 || (_theme$components = theme.components) === null || _theme$components === void 0 || (_theme$components = _theme$components[WrappedComponent.displayName]) === null || _theme$components === void 0 ? void 0 : _theme$components.defaultProps;
    var themePropOverrides = {};
    for (var key in customProps) {
      if (props[key] === undefined) {
        themePropOverrides[key] = customProps[key];
      }
    }
    return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
      ref: ref
    }, customProps, props, themePropOverrides));
  });
};
defaultProps.displayName = "defaultProps";
var _default = exports.default = defaultProps;